import { convertToKebabCase } from '../../../../utils/string-utils';
/**
 * Returns the field ID based on BEM class builder and field name.
 *
 * @param b The BEM class builder.
 * @param name The field name.
 *
 * @example
 * b = 'v-gift-card-payment-form-field';
 * name = 'cardNumber';
 * returns 'v-gift-card-payment-form-field__card-number-input'
 */
export const getFieldId = (b, name) => {
    const nameInKebabCase = convertToKebabCase(name);
    return b.element(`${nameInKebabCase}-input`);
};
/**
 * Returns the field class name based on BEM class builder and field name.
 *
 * @param b The BEM class builder.
 * @param name The field name.
 * @param additionalClassBuilder The BEM class builder for an additional class.
 *
 * @example
 * b = 'v-gift-card-payment-form-field';
 * name = 'cardNumber';
 * returns 'v-gift-card-payment-form-field v-gift-card-payment-form-field--card-number'
 */
export const getFieldClassName = (b, name, additionalClassBuilder) => {
    const nameInKebabCase = convertToKebabCase(name);
    return b.block({ [nameInKebabCase]: true }, additionalClassBuilder === null || additionalClassBuilder === void 0 ? void 0 : additionalClassBuilder.block({ [nameInKebabCase]: true }));
};
